import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

import baseUrl from '../../utils/baseUrl';
import connect from '../../utils/connect';

import Splitter from './block/splitter';
import ContentBlock from './block/content';
import SubmitBlock from './block/submit';

import ConfirmDialog from  '../form/confirm';

import Spinner from '../svg/spinner';
import Form, { formatErrors } from '../form/form';
import InputText from '../form/input/text';
import InputTextarea from '../form/input/textarea';
import InputSubmit from '../form/input/submit';
import InputDropzone from '../form/dropzone/dropzone';
import Label from '../form/label';

import Select from '../form/select/select';

import countriesJSONPath from '../../utils/json/countries.json';

import { dispatchError, dispatchMsg } from '../../actions/errors';
import { getLogin } from '../../actions/users';

import { FormJoinProfile } from './profileEdit/formJoinProfile';
import { ProfileRequest } from './profileEdit/profileRequest';

import axios from 'axios';
import qs from 'qs';

import css from './profileEdit.scss';

class AccountProfileEdit extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		users: PropTypes.object.isRequired,
	};

	static defaultProps = {};

	constructor(props) {
		super();

		this.state = {
			waiting: false,
			loading: true,
			offices: [
				this.newOffice(),
			],
			formErrors: {},
			formValues: {},
			requests: [],
			userRequests: [],
			hasProfile: !!props.users.profile,
		};
	}

	componentDidMount() {
		this.loadData();
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	componentWillReceiveProps(nextProps) {
		if (!this.state.hasProfile && !!nextProps.users.profile) {
			this.state.hasProfile = true;
			this.loadData();
		}
	}

	render() {
		let formErrors = (typeof this.state.formErrors === 'object') ? this.state.formErrors : {};
		let formValues = (typeof this.state.formValues === 'object') ? this.state.formValues : {};

		if (this.state.loading) {
			return this.renderWaiting();
		}

		if (!this.state.hasProfile) {
			return this.renderHasNoProfile(formErrors, formValues);
		}

		return (
			<div className='account-edit-profile'>
				<Helmet title='The FWA - Account - Profile' />
				<ConfirmDialog ref='confirm' />
				{this.renderLeaveProfile('Profile', formValues)}

				{!!(this.props.users.profile && this.props.users.profile.isPoor) && (
					<div className='form-errors' ref='errors'>
						<div className='push5 span9'>
							<ol><li>Your profile is incomplete, please fill out the required fields</li></ol>
						</div>
					</div>
				)}


				<ContentBlock title={'Basic description'}>
					<Label label={'Accounts that are part of ' + formValues.name}></Label>
					<div className='account-block-content__default'>
						{this.renderProfileUsers(formValues.users)}
					</div>
				</ContentBlock>

				{!!(this.state.requests && this.state.requests.length) && (this.state.requests.map(
					(item, i) => {
						return (
							<ProfileRequest
								key={i}
								formValues={formValues}
								item={item}
								index={i}
								approve={() => {
									this.approve(item.user.id, item, `Are you sure you want to approve ${item.user.name}?`);
								}}
								reject={() => {
									this.reject(item.user.id, item, `Are you sure you want to reject ${item.user.name}?`);
								}} />
						);
					}
				))}

				{this.renderProfileForm('', 'put', formErrors, formValues)}
			</div>
		);
	}

	renderLeaveProfile(title, formValues) {
		return (
			<ContentBlock title={title}>
				<div className='account-block-content__default'>
					<div className='span3 span5-tablet span11-mobile account-block-content__default__element'>
						<InputText
							name='fake-name'
							label='Your account is part of the profile:'
							value={formValues.name}
							disabled={true}
							className='' />
					</div>
					<div className='span2 span100p-mobile account-block-content__default__element account-block-content__default__element--no-label'>
						<InputSubmit name='Leave profile' onClick={this.leaveProfile.bind(this)}></InputSubmit>
					</div>
				</div>
			</ContentBlock>
		);
	}

	renderProfileUsers(users) {
		return (
			<ol className='account-edit-profile__users '>
				{(users && users.length) && users.map((user, i) => {
					return (
						<li key={user.id} className='account-edit-profile__users__item'>
							<div className='account-edit-profile__users__item__name span3 span6-tablet span100p-mobile'>
								{user.name} {user.isProfileAdmin ? '(Profile Admin)' : ''}
							</div>
							<div className='account-edit-profile__users__item__mail span3 span6-tablet span100p-mobile'>{user.email}</div>
						</li>
					);
				})}
			</ol>
		);
	}

	renderProfileForm(name, method, formErrors, formValues) {
		return (
			<Form getRefs={() => this.getRefs()} method={method} action={'/api/account/profiles/form'} ref='form' onSubmit={this.onFormSubmit.bind(this)} className='account-block-container'>
				<ContentBlock title={name}>
					<Label label=''></Label>
					<div className='account-block-content__default'>
						<div className='span3 span5-tablet span11-mobile account-block-content__default__section'>
							<InputText
								name='name'
								ref='name'
								label='Name'
								value={formValues.name}
								error={formErrors.hasOwnProperty('name')}
								placeholder=''
								className=''
							/>

							<InputText
								name='website'
								ref='website'
								label='Website URL'
								value={formValues.website}
								error={formErrors.hasOwnProperty('website')}
								placeholder=''
								className=''
							/>

							<InputText
								name='contactEmail'
								ref='contactEmail'
								label='Contact email'
								value={formValues.contactEmail}
								error={formErrors.hasOwnProperty('contactEmail')}
								placeholder=''
								className=''
							/>
						</div>

						<div className='span5 span100p-mobile account-block-content__default__section'>
							<InputTextarea
								name='intro'
								ref='intro'
								label='Introduction text'
								value={formValues.intro}
								error={formErrors.hasOwnProperty('intro')}
								maxChars={250}
								placeholder=''
								rows={5}
								className=''
							/>

						<InputTextarea
								name='additional'
								ref='additional'
								label='Optional additional text'
								btw=' (2 columns)'
								value={formValues.additional}
								error={formErrors.hasOwnProperty('additional')}
								placeholder=''
								rows={5}
								className=''
							/>
						</div>

						<div className='span3 span5-tablet span11-mobile account-block-content__default__section'>
							<InputText
								name='showreel'
								ref='showreel'
								type='url'
								label='Showreel URL'
								btw=' (Vimeo or YouTube)'
								value={formValues.showreel}
								error={formErrors.hasOwnProperty('showreel')}
								placeholder=''
								className=''
							/>
						</div>
					</div>
				</ContentBlock>

				<ContentBlock title={'Social links'}>
					<div className='account-block-content__default'>
						<div className='span3 span5-tablet span11-mobile account-block-content__default__section'>
							<InputText
								name='facebook'
								ref='facebook'
								label='Facebook URL'
								value={formValues.facebook}
								error={formErrors.hasOwnProperty('facebook')}
								placeholder=''
								className=''
							/>

						<InputText
							name='twitter'
							ref='twitter'
							label='Twitter URL'
							value={formValues.twitter}
							error={formErrors.hasOwnProperty('twitter')}
							placeholder=''
							className=''
							/>

						<InputText
							name='linkedin'
							ref='linkedin'
							label='LinkedIn URL'
							value={formValues.linkedin}
							error={formErrors.hasOwnProperty('linkedin')}
							placeholder=''
							className=''
							/>

						<InputText
							name='instagram'
							ref='instagram'
							label='Instagram URL'
							value={formValues.instagram}
							error={formErrors.hasOwnProperty('instagram')}
							placeholder=''
							className=''
							/>
						</div>
					</div>
				</ContentBlock>

				<ContentBlock className='pixel-pattern pixel-pattern--01'></ContentBlock>

				{this.state.offices && this.state.offices.map((office, i) => {
					let officeIdStr = `office[${i}]`;
					let officeId = office.id;

					if (!officeId) {
						return false;
					}

					let formErrorsOffice = (formErrors.offices && formErrors.offices[officeId]) ? formErrors.offices[officeId] : {};

					return (
						<ContentBlock title={i === 0 ? 'Offices' : ''} key={office.id}>
							<div className='account-block-content__default'>
								<div className='span100p account-block-content__default__section'>
									<div className='span3 span5-tablet span11-mobile account-block-content__default__element'>
										{(i === 0) && (<Label label='Office(s)  Min 1. Required' />)}
										<InputText
											name={officeIdStr + '[name]'}
											ref={officeIdStr + '[name]'}
											value={office.name}
											error={formErrors[officeIdStr + '[name]']}
											label={'Office ' + (i + 1)}
											hideLabel={true}
											placeholder='City'
											className=''
										/>
									</div>

									{i > 0 && (
										<div className='span2 span6-mobile account-block-content__default__element'>
											<InputSubmit name='Remove Office' onClick={(e) => { this.removeOffice(e, i); }}></InputSubmit>
										</div>
									)}

								</div>
								<div className='span3 span5-tablet span11-mobile account-block-content__default__section'>

									<InputText
										name={officeIdStr + '[address1]'}
										ref={officeIdStr + '[address1]'}
										value={office.address1}
										error={formErrors[officeIdStr + '[address1]']}
										label='Address 1'
										placeholder='Address line 1'
										className=''
										/>

									<InputText
										name={officeIdStr + '[address2]'}
										ref={officeIdStr + '[address2]'}
										value={office.address2}
										error={formErrors[officeIdStr + '[address2]']}
										label='Address 2'
										placeholder='Address line 2'
										className=''
										/>

									<InputText
										name={officeIdStr + '[address3]'}
										ref={officeIdStr + '[address3]'}
										value={office.address3}
										error={formErrors[officeIdStr + '[address3]']}
										label='Address 3'
										placeholder='Address line 3'
										className=''
										/>

									<InputText
										name={officeIdStr + '[phone]'}
										ref={officeIdStr + '[phone]'}
										value={office.phone}
										error={formErrors[officeIdStr + '[phone]']}
										label='Phone'
										placeholder='Phone'
										className=''
										/>

									<InputText
										name={officeIdStr + '[email]'}
										ref={officeIdStr + '[email]'}
										value={office.email}
										error={formErrors[officeIdStr + '[email]']}
										label='Office Email'
										placeholder='Email'
										className=''
										/>

									<Label label='Country' />
									<Select
										name={officeIdStr + '[country]'}
										ref={officeIdStr + '[country]'}
										value={office.country}
										error={formErrors[officeIdStr + '[country]']}
										placeholder='Country'
										label={'Country ' + (i + 1)}
										className=''
										ajaxOptionsUrl={countriesJSONPath}
										/>
								</div>
							</div>
						</ContentBlock>
					);
				})}

				<ContentBlock className='pixel-pattern pixel-pattern--01'>
					<button className='button button--dark button--no-margin' onClick={this.addOffice.bind(this)}>Add office</button>
				</ContentBlock>

				<ContentBlock title={'Profile header image'}>
					<Label label='Header Image' btw=' 1364 · 620 jpg / png' />
					<InputDropzone
						ref='hero'
						aspect={(620 / 1364)}
						width={354}
						path={'/api/account/profiles/form/image'}
						inputs={[
							{ name: 'hero', preview: (this.state.formValues.hero ? this.state.formValues.hero['538'].span14 : false), error: this.state.formErrors.hero },
						]}
						recommended={{
							width: 1364,
							height: 620,
						}}
						accept='image/*'
					/>
				</ContentBlock>

				<ContentBlock title={'Logos'}>
					<div className='span2 span100p-tablet span100p-mobile account-edit-profile__logo__container'>

						<Label label='Profile list' btw=' 194 · 128 jpg / png' />
						<InputDropzone
							ref='logo'
							aspect={0.659793814}
							width={97}
							path={'/api/account/profiles/form/image'}
							inputs={[
								{ name: 'logo', preview: (this.state.formValues.logo ? this.state.formValues.logo.normal.src : false), error: this.state.formErrors.logo },
							]}
							accept='image/*'
							className='form-dropzone--logo-cont'
							/>

						<div className='account-edit-profile__logo__text' onClick={(e) => { this.refs.logo.open(); }}>
							{((this.props.browser.window.width <= 719) && (
								<span>Tap to upload a new image</span>
							)) || (
								<span>Drag an image here or <a href='#'>browse</a> to upload.</span>
							)}
						</div>

					</div>
					<div className='span6 span100p-tablet span100p-mobile'>

						<Label label='Profile  page' btw=' 428 · 80 jpg / png' />
						<InputDropzone
							ref='logoProfile'
							aspect={0.186915888}
							width={428}
							path={'/api/account/profiles/form/image'}
							inputs={[
								{ name: 'logoProfile', preview: (this.state.formValues.logoProfile ? this.state.formValues.logoProfile.normal.src : false), error: this.state.formErrors.logoProfile },
							]}
							accept='image/*' />
					</div>
				</ContentBlock>

				<SubmitBlock>
					<div className='span3 span8-mobile'>
						<InputSubmit name='Save changes' waiting={this.state.waiting} />
					</div>
					<div className='cf'></div>
				</SubmitBlock>
			</Form>
		);
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<ConfirmDialog ref='confirm' />
				<Spinner size='60' />
			</div>
		);
	}

	renderHasNoProfile(formValues, formErrors) {
		return (
			<div className='account-edit-profile'>
				<Helmet title='The FWA - Account - Profile' />
				<ConfirmDialog ref='confirm' />
				<FormJoinProfile dispatch={this.props.dispatch} userRequests={this.state.userRequests} />
				{this.renderProfileForm('Create profile', 'post', formValues, formErrors)}
			</div>
		);
	}

	loadData() {
		if (this.state.hasProfile) {
			axios.all([
				axios.get(baseUrl + '/api/account/profiles/form'),
			])
			.then(axios.spread((formResponse) => {
				if (this.unmounted) {
					return false;
				}

				let newState = { ...this.state, loading: false };
				if (formResponse.data && formResponse.data.profile) {
					let profile = formResponse.data.profile;
					newState.formValues = profile;

					if (profile.offices && profile.offices.length) {
						newState.offices = profile.offices;
					}
				}

				if (formResponse.data && formResponse.data.requests) {
					newState.requests = formResponse.data.requests;
				}

				this.setState(newState);
			}))
			.catch((res) => {
				this.props.dispatch(dispatchError((res.data && res.data.message) ? res.data : 'An error occurred.'));
			});
		} else {
			axios.all([
				axios.get(baseUrl + '/api/account/profiles/form'),
			])
			.then(axios.spread((formResponse) => {
				if (this.unmounted) {
					return false;
				}

				let newState = { ...this.state, loading: false };

				if (formResponse.data && formResponse.data.requests && formResponse.data.requests[0]) {
					newState.userRequests = formResponse.data.requests;
				}

				this.setState(newState);
			}))
			.catch((res) => {
				this.props.dispatch(dispatchError((res.data && res.data.message) ? res.data : 'An error occurred.'));
				this.mounted && this.setState({
					...this.state,
					loading: false,
				});
			});
		}
	}

	getRefs() {
		return this.refs;
	}

	leaveProfile(e) {
		e.preventDefault();

		this.refs.confirm && this.refs.confirm.confirm('Are you sure you want to leave the profile?')
		.then(() => {
			axios.post(baseUrl + '/api/account/profiles/leave')
			.then((res) => {
				this.props.dispatch(getLogin());
				this.setState({
					...this.state,
					hasProfile: false,
					waiting: false,
					loading: false,
					offices: [
						this.newOffice(),
					],
				});
			})
			.catch((res) => {
				this.props.dispatch(dispatchError((res.data && res.data.message) ? res.data : 'An error occurred.'));
			});
		})
		.catch(() => {});
	}

	addOffice(e) {
		e.preventDefault();
		let newState = {
			...this.state,
			offices: [
				...this.state.offices,
				this.newOffice(),
			],
		};

		this.setState(newState);
	}

	removeOffice(e, index) {
		e.preventDefault();

		this.refs.confirm && this.refs.confirm.confirm('Are you sure you want to remove this office?')
		.then(() => {
			let newState = { ...this.state };

			newState.offices.splice(index, 1);
			this.setState(newState);
		})
		.catch(() => {});
	}

	newOffice() {
		return {
			id: Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1),
			city: '',
			street: '',
			phone: '',
			country: '',
		};
	}

	onFormSubmit(promise) {
		if (this.refs.form && this.refs.form.serialize) {
			this.setState({ ...this.state, waiting: true });
			promise
			.then((res) => {
				this.setState({ ...this.state, waiting: false, formErrors: {} });

				if (res.data && res.data.message) {
					this.props.dispatch(dispatchMsg(res.data));
				}

				this.props.dispatch(getLogin());
			})
			.catch((res) => {
				this.setState({
					...this.state,
					waiting: false,
					formErrors: (typeof res.data.errors === 'object') ? res.data.errors : {},
				});

			});
		}
	}

	approve(userId, item, msg) {
		if (!userId) {
			return false;
		}

		this.answerRequest(baseUrl + `/api/account/profiles/user/${userId}/approve`, userId, item, msg);
	}

	reject(userId, item, msg) {
		if (!userId) {
			return false;
		}

		this.answerRequest(baseUrl + `/api/account/profiles/user/${userId}/reject`, userId, item, msg);
	}

	answerRequest(path, userId, item, msg = 'Are you sure?') {
		this.refs.confirm && this.refs.confirm.confirm(msg)
		.then(() => {
			axios.post(path, qs.stringify({
				userId: userId,
			}))
			.then(() => {
				let index = this.state.requests.indexOf(item);
				let nRequests = (() => {
					let nRequests = [];
					for (var i = 0; i < this.state.requests.length; i++) {
						if (item !== this.state.requests[i]) {
							nRequests.push(this.state.requests[i]);
						}
					}
					return nRequests;
				})();

				this.setState({
					...this.state,
					requests: nRequests,
				});

				this.loadData();
			})
			.catch((res) => {
				this.loadData();
			});
		})
		.catch((res) => {

		});
	}
}

export default connect(AccountProfileEdit);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/profileEdit.js
 **/